/**
 * @generated SignedSource<<77e486078cc74b00e2d44e57ec3d5a9b>>
 * @relayHash 2cc6fed42463066ce74de984705c8901
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9e5acb1b69d72b5f8949c4a0d1b6fd803239e4dc65235c8616787431e319d66f

import type { ConcreteRequest } from 'relay-runtime';
export type JiraSetIsFavouriteInput = {
  beforeEntityId?: string | null;
  entityId: string;
  isFavourite: boolean;
};
export type FavoriteChangeConsumerMutation$variables = {
  input: JiraSetIsFavouriteInput;
};
export type FavoriteChangeConsumerMutation$data = {
  readonly jira: {
    readonly setEntityIsFavourite: {
      readonly favouriteValue: {
        readonly id: string;
        readonly isFavourite: boolean | null;
      } | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type FavoriteChangeConsumerMutation = {
  response: FavoriteChangeConsumerMutation$data;
  variables: FavoriteChangeConsumerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraSetIsFavouritePayload",
        "kind": "LinkedField",
        "name": "setEntityIsFavourite",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FavoriteChangeConsumerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FavoriteChangeConsumerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9e5acb1b69d72b5f8949c4a0d1b6fd803239e4dc65235c8616787431e319d66f",
    "metadata": {},
    "name": "FavoriteChangeConsumerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7a3ceb525a45608774dd6c925108a05f";

export default node;
